import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { WorkflowContextBase } from './WorkflowContextBase';

export class SendTaskRemindersContext extends WorkflowContextBase {
    _originalTypeClassName = "zPMO.BO.SendTaskRemindersContext";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SendTaskRemindersContext.translate = translateService;
}
super();
this._key = this.Id = "00000000-0000-0000-0000-000000000000"; 
}

static translate: TranslateService;
_key: any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "00000000-0000-0000-0000-000000000000";
            }


}